import { derived } from "svelte/store";
import { currentOrganization, organizationStore } from "./organizations";
import {
        kvkFieldValidator,
        requiredFieldValidator,
        branchFieldValidator,
        lettersOnlyFieldValidator
} from "../common/validation/validators";
import { every } from 'lodash';

export const organizationsValidation = derived(
    currentOrganization,
    $currentOrganization => ({
        nameResult: requiredFieldValidator(true, $currentOrganization.name),
        kvkResult: kvkFieldValidator(true, $currentOrganization.kvk),
        streetResult: requiredFieldValidator(true, $currentOrganization.street),
        numberResult: requiredFieldValidator(true, $currentOrganization.number),
        postCodeResult: requiredFieldValidator(true, $currentOrganization.postCode),
        cityResult: lettersOnlyFieldValidator(true, $currentOrganization.city),
        countryResult: requiredFieldValidator(true, $currentOrganization.country),
        branchResult: branchFieldValidator(true, $currentOrganization.branch)
    })
)

export const organizationsSaveState = derived(organizationsValidation, currentOrganizationValidations =>
    every(currentOrganizationValidations, 'valid'))

export const organizationsPageState = derived(organizationStore, organizations => organizations.length > 0)
